import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navType = useNavigationType();

  // Skip scroll-to-top on chat/messages routes to preserve conversation position
  const isChatRoute = /\/(messages|chat)(\/|$)/.test(pathname);

  useEffect(() => {
    if (isChatRoute) return;

    // Scroll on all navigation types including initial load
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      if (typeof document !== "undefined") {
        document.querySelectorAll("main").forEach((el) => {
          el.scrollTop = 0;
        });
      }
    }

    // Focus management: move focus to main content on route change for a11y
    requestAnimationFrame(() => {
      const main = document.getElementById("main-content");
      if (main) {
        main.focus({ preventScroll: true });
      }
    });
  }, [pathname, isChatRoute]);

  return null;
};
